import { LitAPIResponseSchema } from "@/types";
import type { SrpRequestParams } from "hsl-core/SRP";
import { SRP } from "hsl-core/providers";

export default function useLiteratureStructure(
	id?: number,
	params?: SrpRequestParams,
	baseURL?: string,
) {
	const pathname = `/srp/api/literature-structure/${id}`;
	const enabled = !!id;
	return SRP.useSRP(pathname, enabled, params, LitAPIResponseSchema, baseURL);
}
